import React from 'react';
import { Menu, Image } from 'semantic-ui-react';

export default function HeaderMenu() {
    return(
        <Menu fixed='top'>
            <Menu.Menu position='left'>
                <Menu.Item><Image size='mini' style={{ marginRight:'30px' }} src={process.env.REACT_APP_PUBLIC_URL + '/assets/branding-logo.png'} /><span style={{ fontWeight:'800' }}>{process.env.REACT_APP_BRANDING_NAME}</span></Menu.Item>
            </Menu.Menu>
            <Menu.Menu position='right'>
                <Menu.Item><span style={{ fontWeight:'200' }}>Platinum WebJail</span><Image size='mini' style={{ marginLeft:'30px' }} src={process.env.REACT_APP_PUBLIC_URL + '/assets/android-chrome-512x512.png'} /></Menu.Item>
            </Menu.Menu>
        </Menu>
    );
}


// WEBPACK FOOTER //
// ./src/components/Menu.js